import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";
i18n.use(reactI18nextModule).init({
  resources: {
    en: {
      translation: {
     // Travel Expenses VİEWS page
        title: "Harcırah",
        switchToEmployeeView: "Switch to Employee View",
        switchToManagerView: "Switch to Manager View",
        travelExpense: "Travel Expense",
        travelExpenseEntry: "Travel Expenses Entry",
        travelExpensesViews: "Travel Expenses Views",
        reports: "REPORTS",
        accountantApproval: "Accountant Approval",
        home:"Home",
        payrollTransfer: "Payroll Transfer",
        groupName: "Group Name",
        guessedTravelExpenseCost : "Guessed Travel Expense Cost",
        domesticAccommodationLimit: "Domestic Individual Accommodation Limit",
        overseasAccommodationLimits: "Overseas Individual Accommodation Limits",
        domesticAllowanceLimit: "Domestic Allowance Limit",
        overseasAllowanceLimit: "Overseas Allowance Limit",
        approved: "Approved",
        rejected: "Rejected",
        waiting: "Waiting",
        total: "Total",
        domestic: "Domestic",
        overseas: "Overseas",
        travelStartDate: "Travel Start Date",
        travelStartTime: "Travel Start Time",
        travelEndDate: "Travel End Date",
        travelEndTime: "Travel End Time",
        destinationCity: "Destination City(s)",
        chooseCity: "Choose City(s)",
        choose: "Choose",
        reasonForTravel: "Travel Reason",
        explanation: "Explanation",
        countryOfDestination: "Country of destination",
        isThereAccommodation: "Is there Individual Accommodation?",
        howManyDaysAccommodation: "How many days is Individual Accommodation?",
        youWillNetIndividualAccommodation: "You will receive a net individual accommodation payment.",
        yes: "Yes",
        no: "No",
        saveTravelExpense: "SAVE TRAVEL EXPENSE",

        confirmMessage:
          "I accept and confirm the accuracy of the information I have entered above.",
        jobStartDate: "Job Start Date",
        jobStartTime: "Job Start Time",
        country: "Country",
        passportNo: "Passport No",
        visaStatus: "Visa Status",
        visa:"Visa",
        businessGroup: "Business Group",
        peopleYouTravelWith: "People You Travel With",
        peopleTravelingTogether: "People traveling together",
        descriptionTravelDetail: "Please describe your reason for travel in detail.",
        submitAgainForManagerApproval: "Submit Again for Manager Approval",
        travelTime:"Travel Time",
        travelNumber:"Travel Number",

        //Request Validator
        multiGroupInformationNotDefined: "Travel Expense {{index}} Request : Group information is not defined. Consult your manager.",
        groupInformationNotDefined: "Group information is not defined. Consult your manager.",
        requestCannotBeCreatedOutsideDateRange: "Requests cannot be created outside the specified date range.",
        multiRequestCannotBeCreatedOutsideDateRange: "Travel Expense {{index}} Request : Requests cannot be created outside the specified date range.",
        chooseYourTravelStartDate: "Choose your travel start date!",
        multiChooseYourTravelStartDate: "Travel Expense {{index}} Request : Choose your travel start date!",
        chooseYourTravelStartTime: "Choose your travel start time!",
        multiChooseYourTravelStartTime: "Travel Expense {{index}} Request : Choose your travel start time!",
        chooseYourTravelEndDate: "Choose your travel end date!",
        multiChooseYourTravelEndDate: "Travel Expense {{index}} Request : Choose your travel end date!",
        chooseYourTravelEndTime: "Choose your travel end time!",
        multiChooseYourTravelEndTime: "Travel Expense {{index}} Request : Choose your travel end time!",
        endTimeMustBeMore: "The end time must be 30 minutes more than the start time.",
        multiEndTimeMustBeMore: "Travel Expense {{index}} Request : The end time must be 30 minutes more than the start time.",
        cannotTravelExpenceOnPuclicHoliday:"You cannot claim travel expense on public holidays.",
        multiCannotTravelExpenceOnPuclicHoliday:"Travel Expense {{index}} Request : You cannot claim travel expense on public holidays.",
        connotTravelExpenceClaimOnSundays: "You cannot claim travel expense on Sundays",
        multiConnotTravelExpenceClaimOnSundays: "Travel Expense {{index}} Request : You cannot claim travel expense on Sundays",
        chooseCitiesTraveled: "Choose cities traveled!",
        multiChooseCitiesTraveled: "Travel Expense {{index}} Request : Choose cities traveled!",
        connotBeClaimedForDailyTripsInNearbyProvices: "Travel expense cannot be claimed for daily trips in nearby provinces!",
        multiConnotBeClaimedForDailyTripsInNearbyProvices: "Travel Expense {{index}} Request : Travel expense cannot be claimed for daily trips in nearby provinces!",
        forwadDateddomesticAllowanceCannotBe: "A forward-dated domestic allowance cannot be requested.",
        multiForwadDateddomesticAllowanceCannotBe: "Travel Expense {{index}} Request : A forward-dated domestic allowance cannot be requested.",
        notPossibleEnterTravelExpenseDuringWorkingHours: "It is not possible to enter travel expense during working hours!",
        multiNotPossibleEnterTravelExpenseDuringWorkingHours: "Travel Expense {{index}} Request : It is not possible to enter travel expense during working hours!",
        selectCountyOfTravel: "Select the country of travel!",
        multiSelectCountyOfTravel: "Travel Expense {{index}} Request : Select the country of travel!",
        chooseJobStartDate: "Please choose a job start date!",
        multiChooseJobStartDate: "Travel Expense {{index}} Request : Please choose a job start date!",
        chooseJobStarTime: "Select the job start time!",
        multiChooseJobStarTime: "Travel Expense {{index}} Request : Select the job start time!",
        enterPassportNumber: "Enter your passport number!",
        multiEnterPassportNumber: "Travel Expense {{index}} Request : Enter your passport number!",
        chooseViseStatus: "Please choose visa status!",
        multiChooseViseStatus: "Travel Expense {{index}} Request : Please choose visa status!",
        specifyTheIndividualStayDay: "Specify the individual stay day!",
        multiSpecifyTheIndividualStayDay: "Travel Expense {{index}} Request : Specify the individual stay day!",
        connotEnterIndividualAccommodationMoreThan: "You cannot enter individual accommodation for more than the day you travel.",
        multiConnotEnterIndividualAccommodationMoreThan: "Travel Expense {{index}} Request : You cannot enter individual accommodation for more than the day you travel.",
        chooseReasonForTravel: "Please choose a reason for travel!",
        multiChooseReasonForTravel: "Travel Expense {{index}} Request : Please choose a reason for travel!",
        reasonForTravelWarning: "For per diem requests related to your travel reasons Fair/Congress (All-Inclusive) and SSC Meeting, individual accommodation cannot be specified !",
        enterTripDescription: "Enter the trip description!",
        multiEnterTripDescription: "Travel Expense {{revision}} Request : Enter the trip description!",
        nameAndSurname: "Name and Surname",
        requestDetail: "Request Detail",
        revisions: "Revisions",
        approve: "Approve",
        close:"Close",
        back: "Back",

        //status
        all:"All",
        aWaitingApproval: "Awaiting Approval",
        aWaitingAccountantApproval: "Awaiting Accountant Approval",
        waitingForCancelConfirmation:"Waiting for Cancellation Confirmation",
        cancellations:"Cancellations",
        approvals: "Approved",
        rejects: "Rejects",
        pending: "Awaiting Approval",
        transferredPayrolls: "Transferred Payrolls.",
        nonTransferredPayrolls: "Non Transferred Payrolls.",

        transferAllPayroll: "TRANSFER ALL PAYROLL",
        transferChosenPayrolls: "TRANSFER CHOSEN PAYROLLS",
        allChoseNonChoose:  "ALL CHOSE / NON-CHOSE",
        approveChosen: "APPROVE CHOSEN",

        // Travel expenses view
        month: "Month",
        year: "Year",
        status: "Status",
        travelDate: "Travel Date",
        cityCounty: "City Country",
        travelExpensesGross: "Travel Expenses Amount",
        individualAccommodationNet: "Individual Accommodation Amount",
        transaction: "Transactions",
        yourRequests: "Your Requests",
        // Reports
        detailReport: "Detail Report",
        cost: "Cost",
        costEntry: "Cost Entry",
        costMonitoring: "Cost Monitoring",
        managerApproval: "Manager Approval",
        help: "Help",
        sendExpenseForApproval: "Send the expenses I entered for approval.",
        managers: "Managers",
        logout: "Logout",
        datassistPayrollService: "Datassist Payroll Service",
        downloadReport: "Download Report",
        error: "Error",
        loginAgain: "Login again.",
        sessionExpiredLoginAgain:
          "Your session ha expired. Please, login again.",
        loginOperations: "Login Operations",
        revisionsTotal: "There are {{revisionsTotal}} revisions in total.",
        dataHasNotBeenUpdated: "A data has not been updated.",
        payrollTransferReport: "Payroll Transfer Report",
        export:"Export",
        reportFileName:"TravelExpence-Report.xlsx",
        employeeId: "Employee ID",
        employmentId: "Employment ID",
        travelExpenseGroup: "Travel Expense Group",
        manager: "Manager",
        approvalStatus: "Approval Status",
        managerApprovalDate: "Manager Approval Date",
        travelExpenceLimit: "Travel Expence Limit",
        travelType: "Travel Type",
        traveledCityDomestic:"Traveled City (Domestic)",
        countryOfBusinessTravel:"Business Travel Country",
        transactionDate:"Transaction Data",
        totalDaysTraveled: "Total Days Traveled",
        fullDayHours:"Full Day Hours",
        theFractionalHour: "The Fractional Hour",
        fullDayVsHour: "Total Days Traveled",
        fractionalEquivalent: "Fractional Equivalent",
        travelExpensePaymentGross: "Travel Expense Payment (TL)",
        travelExpencePaymentCurrency: "Travel Expense Payment (Currency)",
        individualAccommodationPaymentNetCurrency:"Individual Accommodation Payment Net (Currency)",
        individualAccommodationPaymentNetTl:"Individual Accommodation Payment Net (TL)",
        exchangeType:"Exchange Type",
        exchangeRate:"Exchange Rate",
        transferMonth:"Transfer Month",
        transferYear:"Transfer Year",
        payrollPeriod:"Payroll Period",
        domesticAllowanceAmount:"Domestic Allowance Amount",
        domesticAllowanceTravelTime:"Domestic Allowance Travel Time",
        overseasAllowanceAmountTL:"Overseas Allowance Amount (TL)",
        overseasAllowanceAmountEuro:"Overseas Allowance Amount €",
        overseasAllowanceAmountDollar:"Overseas Allowance Amount $",
        overseansAllowanceTravelTime:"Overseas Allowance Travel Time",
        overseansAllowanceAmount:"Oversenas Travel Expense Amount",
        domesticIndividualAccommodationAmount:"Domestic Individual Accommodation Amount",
        overseansIndividualAccommodationAmountTL: "Overseans Individual Accommodation Amount (TL)",
        overseansIndividualAccommodationAmountEuro: "Overseans Individual Accommodation Amount €",
        overseansIndividualAccommodationAmountDollar: "Overseans Individual Accommodation Amount $",
        currencyInfo: "Currency Information",


        // Tooltip Messages
        moduleTooltip: "Modules",
        languageTooltip: "Languages",

        // Security
        loginOperationList: "Your login operations are listed below",
        loginUserCheck:
          "If you think this user is not yours, please end the sessions.",
        endAllSessions: "End all sessions.",
        openSessionNotFound: "Open sessions were not found!",
        anyManagerConnect:"There is not any manager you are connected to.",

        // ActionsCard
        termClosingDate: "Term Closing Date",
        termClosingInfoMessage: "The travel expenses in the listed report: these expenses have been approved by the Manager <b> until the period closing time.</b>",
        startDate: "Start date",
        endDate: "End date",
        filter: "Filter",
        //Pagination
        prevPage: "Previous Page",
        nextPage: "Next Page",
        //Month
        selectMonth: "Select month.",
        selectYear: "Select year.",
        jan: "January",
        feb: "February",
        mar: "March",
        apr: "April",
        may: "May",
        jun: "June",
        jul: "July",
        aug: "August",
        sep: "September",
        oct: "October",
        nov: "November",
        dec: "December",
        //Requests
        nameSurname: "Name-Surname",
        selection: "Selection",
        //Warning
        sessionExpiredMessage: "Your session has expired. Please login again",
        datesCanNotLeaveEmpty: "Dates can't leave empty",
        endDateCanNotLessStartDate: "End Date cannot be less than Start Date!",
        //Help
        documentDownloadMessage:
          'You can download the travel expense module help document from <a target="_blank" href={{yardimPdf}}>here.</a.<br/><br/>',
        managerApprovelMessage: 'You can check the Manager Approval Dates of the allowances on the <b>Detail Report</b>',
        Harcirah_Genel_Yardim: "Travel_Expense_General_Guide",

         //Info Tooltip
         aWaitingManagerApproval: "Awaiting Manager Approval.",
         aWaitingAccountantApprovalInfo :"Awaiting Accountant Aproval.",
         awaitingCancellationApprove: "Awaiting Cancallation Approve.",
         aWaitingAccountantCancellation: "Awaiting Accountant Cancellation.",

         cancelledInfo: "Cancelled.",
         approvedInfo: "Approved.",
         rejectedInfo: "Rejected.",
         unknownReason: "Unknown reason.",
         waitingToBeTransfer: "Waiting to be transfer.",
         revised: "Revised.",
         travelExpenseGrossPayment: "Travel Expense Payment.",
         individualAccommodationAmount: "Individual accommodation amount.",
         travelExpenseDetail: "Travel Expense Detail.",
         approveCancellationRequest: "Approve Cancellation Request.",
         approveTravelExpense: 'Approve Travel Expense.',
         rejectTravelExpense: "Reject Travel Expense.",
         changeExchangeRate: "Change exchange rate.",
         rejectCancellationRequest: "Reject Cancellation Request.",
         overseasIndividualAccommodationAmountInfo: "Overseas Individual Accommodation Amount",
         download: "Download",
         cancelTravelExpense: "Cancel The Travel Expense",
         editTravelExpense: "Edit The Travel Expense",

          //Server Messages
          successAlertTitle:  "SUCCESS",
          errorAlertTitle: "ERROR",
          expensesSaved  : "Expenses Saved",
          expenseUpdated : "Expense Updated",
          expenseUpdateFailure : "There is an error while updating the expense",
          expenseNotFound:  "Travel expense not found.",
          expenseIdNotFound: "Travel Expense Id not found.",
          expenseCancelRequest : "A cancellation request has been made for the travel expense.",
          expenseCancelled : "The travel expense is cancelled.",
          expenseCancelFailure: "There is occurred an error while cancelling the travel expense.",
          expenseRequestNotFound: "Travel expense request not found.",
          expenseApproved: "Travel expense is approved",
          expenseNotApproved: "Travel expense request not found, please try again.",
          cantApproveIfNotManagerOfExpense: "You cannot approve the travel expense of staff you are not a manager of.",
          dontLeaveFieldEmpty: "Do not leave any field empty.",
          dontLeaveFieldsEmptyAndCalculateExpense: "Do not leave any field empty or calculate travel expense.",
          expenseCalculateFailure: "An error was encountered while calculating the travel expense.",
          expenseFetchingFailure: "An error was encountered while fetching the travel expense.",
          countryListFetchingFailure: "An error was encountered while retrieving the country list.",
          expenseTransferSuccessful: "Travel Expense successfully transferred.",
          expenseRejected: "The travel expense is rejected.",
          expenseRejectedFailure: "The travel expense could not be reject, please try again.",
          cantRejectIfNotManagerOfExpense: "You cannot reject the travel expense of a staff you are not a manager of.",
          expenseDescriptionWarning: "Please enter description.",
          loginAgain: "You do not have access permission! Login again!",
          permissionFailure: "You do not have access permission!",
          visaListEmptyWarning: "Visa is not existed, the mailing list can not be emtpy.",
          sessionEndSuccessful: "Session terminated success.",
          sessionEndFailure: "An error was encountered while terminating session.",
          allApplication:"All Applications",

      },
    },
    // ===========================
    // ===========================
    tr: {
      translation: {
        //harcirah girişi sayfası
        title: "Harcırah",
        switchToEmployeeView: "Çalışan Görünümüne Geç",
        switchToManagerView: "Yönetici Görünümüne Geç",
        travelExpense: "Harcırah",
        travelExpenseEntry: "Harcırah Girişi",
        travelExpensesViews: "Harcırah Görüntüleme",
        reports: "Raporlar",
        accountantApproval: "Muhasebe Onayı",
        home:"Ana Sayfa",
        payrollTransfer: "Puantaj Aktarım",
        //Employee Info
        groupName: "Grup Adı",
        guessedTravelExpenseCost : "Tahmini Harcırah Tutarı",
        domesticAccommodationLimit: "Yurtiçi Bireysel Konaklama Limiti",
        overseasAccommodationLimits: "Yurtdışı Bireysel Konaklama Limitleri",
        domesticAllowanceLimit: "Yurtiçi Harcırah Limiti",
        overseasAllowanceLimit: "Yurtdışı Harcırah Limiti",
        approved: "Onaylanan",
        rejected: "Reddilenler",
        waiting: "Bekleyen",
        total: "Toplam",
        domestic: "Yurtiçi",
        overseas: "Yurtdışı",
        travelStartDate: "Seyahat Başlangıç Tarihi",
        travelStartTime: "Seyahat Başlangıç Saati",
        travelEndDate: "Seyahat Bitiş Tarihi",
        travelEndTime: "Seyahat Bitiş Saati",
        destinationCity: "Gidilen Şehir(ler)",
        chooseCity: "Şehir(ler)i seçin",
        choose: "Seçiniz",
        reasonForTravel: "Seyahat Sebebi",
        explanation: "Açıklama",
        countryOfDestination: "Gidilen Ülke",
        isThereAccommodation: "Bireysel Konaklama var mı?",
        howManyDaysAccommodation: "Bireysel Konaklama kaç gün?",
        youWillNetIndividualAccommodation: "net bireysel konaklama ödemesi alacaksınız.",
        yes: "Evet",
        no: "Hayır",
        saveTravelExpense: "HARCIRAHI KAYDET",
        confirmMessage:
          "Yukarıda girmiş olduğum bilgilerin doğruluğunu kabul ediyor ve onaylıyorum.",
        jobStartDate: "İş Başlangıç Tarihi",
        jobStartTime: "İş Başlangıç Saati",
        country: "Ülke",
        passportNo: "Pasaport No",
        visaStatus: "Vize Durumu",
        visa:"Vize",
        businessGroup: "Iş Grubu",
        peopleYouTravelWith: "Seyahat Ettiğiniz Kişiler",
        peopleTravelingTogether: "Seyahat Ettiği Kişiler",
        descriptionTravelDetail: "Lütfen seyahat sebebinizi detaylı açıklayınız.",
        submitAgainForManagerApproval: "Tekrar Yönetici Onayına Gönder",
        travelTime:"Seyahat Süresi",
        travelNumber:"Seyahat Numarası",

        //Request Validator
        groupInformationNotDefined: "Grup bilgisi tanımlanmamış. Yöneticinize danışınız.",
        multiGroupInformationNotDefined: "Harcırah {{index}} Talebi : Grup bilgisi tanımlanmamış. Yöneticinize danışınız.",
        requestCannotBeCreatedOutsideDateRange: "Belirtilen tarih aralığı dışında talep oluşturulamaz.",
        multiRequestCannotBeCreatedOutsideDateRange: "Harcırah {{index}} Talebi : Belirtilen tarih aralığı dışında talep oluşturulamaz.",
        chooseYourTravelStartDate: "Seyahat başlangıç tarihi seçiniz!",
        multiChooseYourTravelStartDate: "Harcırah {{index}} Talebi : Seyahat başlangıç tarihi seçiniz!",
        chooseYourTravelStartTime: "Seyahat başlangıç saatini seçiniz!",
        multiChooseYourTravelStartTime: "Harcırah {{index}} Talebi : Seyahat başlangıç saatini seçiniz!",
        chooseYourTravelEndDate: "Seyahat bitiş tarihi seçiniz!",
        multiChooseYourTravelEndDate: "Harcırah {{index}} Talebi : Seyahat bitiş tarihi seçiniz!",
        chooseYourTravelEndTime: "Seyahat bitiş saatini seçiniz!",
        multiChooseYourTravelEndTime: "Harcırah {{index}} Talebi : Seyahat bitiş saatini seçiniz!",
        endTimeMustBeMore: "Bitiş saati, başlangıç saatinden 30 dakika fazla olmalıdır.",
        multiEndTimeMustBeMore: "Harcırah {{index}} Talebi : Bitiş saati, başlangıç saatinden 30 dakika fazla olmalıdır.",
        cannotTravelExpenceOnPuclicHoliday: "Resmi tatil günleri harcırah talebinde bulunamazsınız.",
        multiCannotTravelExpenceOnPuclicHoliday: "Harcırah {{index}} Talebi : Resmi tatil günleri harcırah talebinde bulunamazsınız.",
        connotTravelExpenceClaimOnSundays: "Pazar günleri harcırah talebinde bulunamazsınız.",
        multiConnotTravelExpenceClaimOnSundays: "Harcırah {{index}} Talebi : Pazar günleri harcırah talebinde bulunamazsınız.",
        chooseCitiesTraveled: "Seyahat edilen şehirleri seçin!",
        multiChooseCitiesTraveled: "Harcırah {{index}} Talebi : Seyahat edilen şehirleri seçin!",
        connotBeClaimedForDailyTripsInNearbyProvices: "Yakın illerde günübirlik seyahatlerde harcırah talep edilemez!",
        multiConnotBeClaimedForDailyTripsInNearbyProvices: "Harcırah {{index}} Talebi : Yakın illerde günübirlik seyahatlerde harcırah talep edilemez!",
        forwadDateddomesticAllowanceCannotBe: "İleri tarihli yurtiçi harcırah talebinde bulunulamaz.",
        multiForwadDateddomesticAllowanceCannotBe: "Harcırah {{index}} Talebi : İleri tarihli yurtiçi harcırah talebinde bulunulamaz.",
        notPossibleEnterTravelExpenseDuringWorkingHours: "Mesai saatleri içerisinde harcırah girişi yapılamaz!",
        multiNotPossibleEnterTravelExpenseDuringWorkingHours: "Harcırah {{index}} Talebi : Mesai saatleri içerisinde harcırah girişi yapılamaz!",
        selectCountyOfTravel: "Seyahat edilen ülkeyi seçiniz!",
        multiSelectCountyOfTravel: "Harcırah {{index}} Talebi : Seyahat edilen ülkeyi seçiniz!",
        chooseJobStartDate: "İş başlangıç tarihi seçiniz!",
        multiChooseJobStartDate: "Harcırah {{index}} Talebi : İş başlangıç tarihi seçiniz!",
        chooseJobStarTime: "İş başlangıç saatini seçiniz!",
        multiChooseJobStarTime: "Harcırah {{index}} Talebi : İş başlangıç saatini seçiniz!",
        enterPassportNumber: "Pasaport numarası giriniz!",
        multiEnterPassportNumber: "Harcırah {{index}} Talebi : Pasaport numarası giriniz!",
        chooseViseStatus: "Vize durumunu seçiniz!",
        multiChooseViseStatus: "Harcırah {{index}} Talebi : Vize durumunu seçiniz!",
        specifyTheIndividualStayDay: "Bireysel konaklama gününü belirtiniz!",
        multiSpecifyTheIndividualStayDay: "Harcırah {{index}} Talebi : Bireysel konaklama gününü belirtiniz!",
        connotEnterIndividualAccommodationMoreThan: "Seyahat ettiğin günden fazla bireysel konaklama giremezsiniz.",
        multiConnotEnterIndividualAccommodationMoreThan: "Harcırah {{index}} Talebi : Seyahat ettiğin günden fazla bireysel konaklama giremezsiniz.",
        chooseReasonForTravel: "Seyahat sebebi seçiniz!",
        multiChooseReasonForTravel: "Harcırah {{index}} Talebi : Seyahat sebebi seçiniz!",
        reasonForTravelWarning: "Fuar/Kongre (Her Şey Dahil) ve SSC Meeting seyahat sebepleriniz kapsamında yapılacak harcırah taleplerinizde, bireysel konaklama belirtilemez !",
        enterTripDescription:"Seyahat açıklamasını giriniz!",
        multiEnterTripDescription:"Harcırah {{index}} Talebi : Seyahat açıklamasını giriniz!",
        nameAndSurname: "Adı Soyadı",
        requestDetail: "Talep Detayı",
        revisions: "Revizeler",
        approve: "Onayla",
        close :"Kapat",
        back: "Geri",

        //status
        all:"Hepsi",
        aWaitingApproval:"Onay Bekleyenler",
        aWaitingAccountantApproval:"Muhasebe Onayı Bekleyenler",
        waitingForCancelConfirmation:"İptal Onayı Bekleyenler",
        cancellations:"İptal Edilenler",
        approvals: "Onaylananlar",
        rejects: "Reddedilenler",
        pending: "Bekleyenler",
        transferredPayrolls: "Aktarılan Puantajlar",
        nonTransferredPayrolls: "Aktarılmayan Puantajlar",

        transferAllPayroll: "TÜMÜNÜ PUANTAJA AKTAR",
        transferChosenPayrolls: "SEÇİLENLERİ PUANTAJA AKTAR",
        allChoseNonChoose:  "TÜMÜNÜ SEÇ / SEÇME",
        approveChosen:"SEÇİLENLERİ ONAYLA",

        // Travel expenses view
        month: "Ay",
        year: "Yıl",
        status: "Durum",
        travelDate: "Seyahat Tarihi",
        cityCounty: "Şehir / Ülke",
        travelExpensesGross: "Harcırah Tutarı",
        individualAccommodationNet: "Bireysel Konaklama Tutarı",
        transaction: "İşlemler",
        yourRequests: "Talepleriniz",
        //Reports
        detailReport: "Detay raporu",
        cost: "Masraf",
        costEntry: "Masraf Girişi",
        costMonitoring: "Masraf Görüntüleme",
        managerApproval: "Yönetici Onayı",
        help: "Yardım",
        sendExpenseForApproval: "Girdiğim masrafları onaya gönder.",
        managers: "Yöneticiler",
        logout: "Çıkış",
        datassistPayrollService: "Datassist Bordro Servisi",
        downloadReport: "Raporu İndir",
        error: "HATA",
        loginAgain: "Tekrar giriş yapın",
        sessionExpiredLoginAgain:
          "Oturumunuz sonlandı. Lütfen tekrar giriş yapınız.",
        loginOperations: "Giriş İşlemleri",
        revisionsTotal: "Toplamda {{revisionsTotal}} revize bulunuyor.",
        dataHasNotBeenUpdated: "Bir veri güncellenmemiş.",
        payrollTransferReport: "Puantaj Aktarım Raporu",
        export:"Dışarı Aktar",
        reportFileName:"Harcirah-Rapor.xlsx",
        employeeId: "Çalışan ID",
        employmentId: "Çalışma ID",
        travelExpenseGroup: "Harcırah Grubu",
        manager: "Yönetici",
        approvalStatus: "Onay Durumu",
        managerApprovalDate: "Yönetici Onay Tarihi",
        travelExpenceLimit: "Harcırah Limiti",
        travelType: "Seyahat Tipi",
        traveledCityDomestic:"Seyahat Edilen Şehir (Yurtiçi)",
        countryOfBusinessTravel:"İş Seyahatinin Yapılacağı Ülke",
        transactionDate:"Işlem Tarihi",
        totalDaysTraveled: "Seyahat Edilen Toplam Gün",
        fullDayHours:"Tam Gün Saat",
        theFractionalHour: "Küsurat  Saat",
        fullDayVsHour: "Tam Gün Karşılığı Saat Karşılığı",
        fractionalEquivalent: "Küsurat Karşılığı",
        travelExpensePaymentGross: "Harcırah Ödeme Tutarı (TL)",
        travelExpencePaymentCurrency: "Harcırah Ödeme Tutarı (Döviz)",
        individualAccommodationPaymentNetCurrency:"Bireysel Konaklama Ödeme Net (Döviz)",
        individualAccommodationPaymentNetTl:"Bireysel Konaklama Ödeme Net (TL)",
        exchangeType:"Dövüz Turu",
        exchangeRate:"Döviz Kuru",
        transferMonth:"Aktarım Ay",
        transferYear:"Aktarım Yıl",
        payrollPeriod:"Bordro Dönemi",
        domesticAllowanceAmount:"Yurtiçi Harcırah Tutarı",
        domesticAllowanceTravelTime:"Yurtiçi Harcırah Seyahat Süresi",
        overseansAllowanceAmount:"Yurtdışı Harcırah Tutarı",
        overseasAllowanceAmountTL:"Yurtdışı Harcırah Tutarı (TL)",
        overseasAllowanceAmountEuro:"Yurtdışı Harcırah Tutarı €",
        overseasAllowanceAmountDollar:"Yurtdışı Harcırah Tutarı $",
        overseansAllowanceTravelTime:"Yurtdışı Harcırah Seyahat Süresi",
        domesticIndividualAccommodationAmount:"Yurtiçi Bireysel Konaklama Tutarı",
        overseansIndividualAccommodationAmountTL: "Yurtdışı Bireysel Konaklama Tutarı (TL)",
        overseansIndividualAccommodationAmountEuro: "Yurtdışı Bireysel Konaklama Tutarı €",
        overseansIndividualAccommodationAmountDollar: "Yurtdışı Bireysel Konaklama Tutarı $",
        currencyInfo: "Kur Bilgisi",

        // Tooltip Messages
        moduleTooltip: "Modüller",
        languageTooltip: "Diller",


        //Security
        loginOperationList: "Aşağıda giriş işlemleriniz listelenmektedir.",
        loginUserCheck:
          "Eğer kendiniz olmadığını düşünüyorsanız lütfen oturumları sonlandırın.",
        endAllSessions: "Tüm oturumları sonlandır",
        openSessionNotFound: "Açık olan herhangi bir oturum bulunamadı!",
        anyManagerConnect:"Bağlı olduğunuz yönetici bulunmuyor.",

        // ActionsCard
        termClosingDate: "Dönem Kapama Tarihi",
        termClosingInfoMessage: "Listelenen rapordaki harcırahlar; <b>Dönem kapanış zamanına</b> kadarki Yönetici Onayı verilen harcırahlardır.",
        startDate: "Başlangıç tarihi",
        endDate: "Bitiş tarihi",
        filter: "Filtrele",
        //Pagination
        prevPage: "Önceki Sayfa",
        nextPage: "Sonraki Sayfa",

        //Month
        selectMonth: "Ay seçiniz.",
        selectYear: "Yıl seçiniz.",
        jan: "Ocak",
        feb: "Şubat",
        mar: "Mart",
        apr: "Nisan",
        may: "Mayıs",
        jun: "Haziran",
        jul: "Temmuz",
        aug: "Ağustos",
        sep: "Eylül",
        oct: "Ekim",
        nov: "Kasım",
        dec: "Aralık",
        //Requests
        nameSurname: "Ad-Soyad",
        selection: "Seçim",
        //Warning
        sessionExpiredMessage:
          "Oturum süreniz doldu, lütfen tekrar giriş sağlayınız.",
          datesCanNotLeaveEmpty:"Tarihler boş olamaz",
          endDateCanNotLessStartDate:"Bitiş tarihi başlangıç tarihinden küçük olamaz!",
        //Help
        documentDownloadMessage:
          'Harcırah modülü yardım dökümanını <a target="_blank" href={{yardimPdf}}>buradan</a> indirebilirsiniz.<br /><br />',
        managerApprovelMessage: 'Harcırahların Yönetici Onay Tarihlerini <b>Detay Raporu</b> üzerinden kontrol edebilirsiniz',
        Harcirah_Genel_Yardim: "Harcirah_Genel_Yardim",

        //Info Tooltip
        aWaitingManagerApproval: "Yönetici onayı bekliyor.",
        aWaitingAccountantApprovalInfo :"Muhasebe onayı bekliyor.",
        awaitingCancellationApprove: "İptal onayı bekliyor.",
        aWaitingAccountantCancellation: "Muhasebe iptal onayı bekliyor.",

        cancelledInfo: "İptal edildi.",
        approvedInfo: "Onaylandı.",
        rejectedInfo: "Reddedildi.",
        unknownReason: "Bilinmeyen bir durum.",
        waitingToBeTransfer: "Aktarılmayı bekliyor.",
        revised: "Revize edilmiş.",
        travelExpenseGrossPayment: "Harcırah Ödeme",
        individualAccommodationAmount: "Bireysel Konaklama Tutarı",
        travelExpenseDetail: "Harcırah Detayı",
        approveCancellationRequest: "İptal İsteğini Onayla",
        approveTravelExpense: 'Harcırahı Onayla',
        rejectTravelExpense: "Harcırahı Reddet",
        changeExchangeRate: "Döviz kurunu değiştir",
        rejectCancellationRequest: "İptal İsteğini Reddet",
        overseasIndividualAccommodationAmountInfo: "Yurtdışı Bireysel Konaklama Tutarı",
        download: "İndir",
        cancelTravelExpense: "Harcırah İptal Et",
        editTravelExpense: "Harcırah Düzenle",


        //Server Messages
         successAlertTitle:  "BAŞARILI",
         errorAlertTitle:  "HATA",
         expensesSaved  :  "Harcırahlar eklendi.",
         expenseUpdated :  "Harcırah güncellendi.",
         expenseUpdateFailure : "Harcırah güncellenirken bir hata ile karşılaşıldı.",
         expenseNotFound:  "Harcırah bulunamadı.",
         expenseIdNotFound: "Harcırah id bulunamadı.",
         expenseCancelRequest : "Harcırah iptal talebinde bulunuldu.",
         expenseCancelled : "Harcırah iptal edildi.",
         expenseCancelFailure: "Harcırah iptal edilirken bir hata ile karşılaşıldı.",
         expenseRequestNotFound: "Harcırah talebi bulunmadı.",
         expenseApproved: "Harcırah onaylandı.",
         expenseNotApproved: "Harcırah onaylanamadı, lütfen tekrar deneyin.",
         cantApproveIfNotManagerOfExpense: "Yöneticisi olmadığınız personelin harcırahını onaylayamazsınız.",
         dontLeaveFieldEmpty: "Boş alan bırakmayın.",
         dontLeaveFieldsEmptyAndCalculateExpense: "Boş alan bırakmayın veya harcırahı hesaplatın.",
         expenseCalculateFailure: "Harcırah hesaplanırken bir hata ile karşılaşıldı.",
         expenseFetchingFailure: "Harcırah getirilirken bir hata ile karşılaşıldı.",
         countryListFetchingFailure: "Ülke listesi alınırken bir hata ile karşılaşıldı.",
         expenseTransferSuccessful: "Puantaja başarıyla aktarıldı.",
         expenseRejected: "Harcırah reddedildi.",
         expenseRejectedFailure: "Harcırah reddedilemedi, lütfen tekrar deneyin.",
         cantRejectIfNotManagerOfExpense: "Yöneticisi olmadığınız personelin harcırahını reddedemezsiniz.",
         expenseDescriptionWarning: "Lütfen açıklama giriniz.",
         loginAgain: "Erişim izniniz bulunmuyor! Tekrar login olunuz !",
         permissionFailure: "Erişim izniniz bulunmuyor!",
         visaListEmptyWarning: "Vize yok seçili olduğundan mail gönderilecekler listesi dolu olmalıdır.",
         sessionEndSuccessful: "Oturumlar başarıyla sonlandırıldı.",
         sessionEndFailure: "Oturumlar sonlandırılırken bir hata ile karşılaşıldı.",
         allApplication:"Tüm Uygulamalar",

      },
    },
  },
  lng: "tr",
  fallbackLng: "tr",
  interpolation: {
    escapeValue: false,
  },
});
export default i18n;



// WEBPACK FOOTER //
// ./src/constants/i18n.js